import { render, staticRenderFns } from "./EditDocumentDialog.vue?vue&type=template&id=7a2ee38e&"
import script from "./EditDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./EditDocumentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports